import { render, staticRenderFns } from "./table-rhp.vue?vue&type=template&id=70e63919"
import script from "./table-rhp.vue?vue&type=script&lang=js"
export * from "./table-rhp.vue?vue&type=script&lang=js"
import style0 from "./table-rhp.vue?vue&type=style&index=0&id=70e63919&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports